import { datadogRum } from '@datadog/browser-rum';
import { User } from 'types';

type userKeys = keyof User;

export const setUserProperty = <K extends userKeys = userKeys>(property: K, value: User[K]) => {
  datadogRum.setUserProperty(property, value);
};
